<!--短信余额查询-->
<template>
  <div class="app-container">
    <el-card class="operate-container" shadow="never">
      <div class="filter-container" style="height: 150px;">
        <div class="top-con">
            <div class="title-con2">目前短信剩余条数:</div>
            <div v-if="remVccCounts <= 100" class="value-1">
              {{remVccCounts}}
            </div>
            <div v-else class="value-2">
              {{remVccCounts}}
            </div>
        </div>

        <div class="top-con">
            <div class="title-con2">总语音短息条数:</div>
            <div class="value-2">
              {{totalTtsCount}}
            </div>
            <div class="title-con2">上月语音短息条数:</div>
            <div class="value-2">
              {{lastMonthTtsCount}}
            </div>
        </div>
      </div>
    </el-card>








  </div>


</template>

<style scoped>
  .top-con{
    width: 100%;
    height: 90px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
  }
  .title-con2{
    color: white;
    font-weight: 500;
    font-size: 20px;
    line-height: 52px;
    text-align: center;
    padding-left: 35px;
    padding-right: 35px;
    border-radius: 8px;
    background: linear-gradient(120.93deg, #f49b0b 3.98%, #f7b954 100%);
    /* 卡片阴影 */
    box-shadow: 0px 0px 8px 2px rgba(191, 45, 28, 0.09);
  }
  .value-1{
    color: #F56C6C;
    font-size: 25px;
    font-weight: 600;
    margin-left: 20px;
  }
  .value-2{
    color: #00b600;
    font-size: 25px;
    font-weight: 600;
    margin-left: 20px;
  }

</style>

<script>


  import globaldata from "../../../utils/globaldata";
  import {getStoreRemVccCounts} from "../../../api/StoreSetting";
  import commonUtils from "../../../utils/commonUtils";

  export default {

    data() {
      return {
        remVccCounts: 0,
        totalTtsCount: 0,
        lastMonthTtsCount: 0,
      }
    },
    created(){

      this.init();

    },
    mounted() {

    },
    methods: {

      init(){
        let param = {
          id:globaldata.getAdminStore().storeFrontId,
        }
        getStoreRemVccCounts(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.remVccCounts =data.remVccCounts;
          this.totalTtsCount =data.totalTtsCount;
          this.lastMonthTtsCount =data.lastMonthTtsCount;
        })
      }


    }
  }
</script>






// WEBPACK FOOTER //
// src/views/consume/vcc-rem-counts/index.vue